export const baseSpacing = 8;
export const mobileMaxWidthBreakpoint = '600px';
